const style = {
  state: {
    config: {}
  },
  mutations: {
    changeConfig(state, payload) {
      state.config = payload;
    }
  }
};

export default style;
